import type { ChainId } from '$lib/models'

export type ChainSocials = {
	website: string
	twitter: string
	discord?: string
	telegram?: string | string[]
	github?: string | string[]
	reddit?: string
	youtube?: string
}

/* eslint sort-keys: ["error", "asc", { caseSensitive: true, natural: true }] */
export const CHAINS_SOCIALS: Record<ChainId, ChainSocials> = {
	acala_chain: {
		discord: 'https://discord.com/invite/B9v7JEq',
		github: 'https://github.com/AcalaNetwork/Acala',
		telegram: 'https://t.me/acalaofficial',
		twitter: 'https://x.com/AcalaNetwork',
		website: 'https://acala.network',
	},
	aelf_chain: {
		discord: 'https://discord.gg/aelfblockchain',
		github: 'https://github.com/aelfProject',
		telegram: 'https://t.me/aelfblockchain',
		twitter: 'https://x.com/aelfblockchain',
		website: 'https://aelf.com/',
	},
	aeternity_chain: {
		discord: 'https://discord.com/invite/55f8F2jZq4',
		github: 'https://github.com/aeternity',
		reddit: 'https://www.reddit.com/r/Aeternity/',
		telegram: 'https://telegram.me/aeternity',
		twitter: 'https://x.com/aeternity',
		website: 'https://aeternity.com/',
		youtube: 'https://www.youtube.com/@aeternityblockchain',
	},
	airdao_chain: {
		discord: 'https://discord.gg/airdao',
		github: 'https://github.com/ambrosus',
		reddit: 'https://www.reddit.com/r/AirDAO/',
		telegram: 'https://t.me/airDAO_official',
		twitter: 'https://x.com/airdao_io',
		website: 'https://airdao.io/',
		youtube: 'https://www.youtube.com/@airdao_official',
	},
	ajuna_chain: {
		discord: 'https://discord.gg/cE72GYcFgY',
		github: 'https://github.com/ajuna-network/',
		reddit: 'https://www.reddit.com/user/Ajuna_Network/',
		telegram: 'https://t.me/ajunanetwork',
		twitter: 'https://x.com/AjunaNetwork',
		website: 'https://ajuna.io',
	},
	aleph_zero_chain: {
		discord: 'https://discord.gg/alephzero',
		reddit: 'https://www.reddit.com/r/AlephZero',
		telegram: 'https://t.me/AlephZeroFoundation',
		twitter: 'https://x.com/Aleph__Zero',
		website: 'https://alephzero.org/',
		youtube: 'https://youtube.com/@AlephZero',
	},
	alephium_chain: {
		discord: 'https://discord.gg/XC5JaaDT7z',
		github: 'https://github.com/alephium',
		reddit: 'https://www.reddit.com/r/Alephium',
		telegram: 'https://t.me/alephiumgroup',
		twitter: 'https://x.com/alephium',
		website: 'https://alephium.org/',
		youtube: 'https://www.youtube.com/@alephium',
	},
	algorand_chain: {
		discord: 'https://discord.gg/algorand',
		github: 'https://github.com/algorand/',
		reddit: 'https://www.reddit.com/r/algorand/',
		telegram: 'https://t.me/algorand',
		twitter: 'https://x.com/algorand',
		website: 'https://algorand.com/',
		youtube: 'https://www.youtube.com/algorand',
	},
	aptos_chain: {
		discord: 'https://discord.com/invite/aptosnetwork',
		github: 'https://github.com/aptos-foundation',
		reddit: 'https://www.reddit.com/r/Aptos/',
		telegram: 'https://t.me/aptos',
		twitter: 'https://x.com/aptos',
		website: 'https://aptosfoundation.org/',
		youtube: 'https://www.youtube.com/@aptosnetwork',
	},
	arbitrum_chain: {
		discord: 'https://discord.gg/arbitrum',
		reddit: 'https://www.reddit.com/r/Arbitrum/',
		telegram: 'https://t.me/arbitrum',
		twitter: 'https://x.com/arbitrum',
		website: 'https://arbitrum.io/',
		youtube: 'https://www.youtube.com/arbitrum',
	},
	areon_chain: {
		discord: 'https://discord.com/invite/AreonNetwork',
		github: 'https://github.com/Areon-Network',
		reddit: 'https://www.reddit.com/r/areon/',
		telegram: 'https://t.me/areonnetwork',
		twitter: 'https://x.com/AreonNetwork',
		website: 'https://areon.network/',
		youtube: 'https://www.youtube.com/@AreonNetworkOfficial',
	},
	arthera_chain: {
		discord: 'https://discord.com/invite/arthera',
		telegram: 'https://t.me/artherachain',
		twitter: 'https://x.com/artherachain',
		website: 'https://www.arthera.net/',
		youtube: 'https://www.youtube.com/@Artherachain',
	},
	astar_chain: {
		discord: 'https://discord.com/invite/astarnetwork',
		github: 'https://github.com/AstarNetwork/Astar',
		telegram: 'https://t.me/PlasmOfficial',
		twitter: 'https://x.com/AstarNetwork',
		website: 'https://astar.network',
	},
	aura_chain: {
		discord: 'https://discord.com/invite/Y3RZDrregV',
		telegram: 'https://t.me/AuraNetworkOfficial',
		twitter: 'https://x.com/AuraNetworkHQ',
		website: 'https://aura.network/',
	},
	aurora_chain: {
		discord: 'https://discord.gg/auroralabs',
		github: 'https://github.com/aurora-is-near',
		twitter: 'https://x.com/auroraisnear',
		website: 'https://aurora.dev/',
		youtube: 'https://www.youtube.com/c/auroraisnear',
	},
	autonomys_chain: {
		discord: 'https://autonomys.xyz/discord',
		github: 'https://github.com/autonomys',
		telegram: 'https://t.me/subspace_network',
		twitter: 'https://x.com/AutonomysNet',
		website: 'https://www.autonomys.xyz/',
		youtube: 'https://www.youtube.com/@AutonomysNetwork',
	},
	avalanche_chain: {
		discord: 'https://discord.com/invite/avax',
		reddit: 'https://www.reddit.com/r/Avax/',
		telegram: 'https://t.me/avalancheavax',
		twitter: 'https://x.com/avax',
		website: 'https://www.avax.network/',
		youtube: 'https://www.youtube.com/Avalancheavax',
	},
	base_chain: {
		discord: 'https://discord.com/invite/buildonbase',
		twitter: 'https://x.com/base',
		website: 'https://base.org/',
	},
	berachain_chain: {
		discord: 'https://discord.com/invite/berachain',
		github: 'https://github.com/berachain',
		telegram: 'https://t.me/BerachainPortal',
		twitter: 'https://x.com/berachain',
		website: 'https://www.berachain.com/',
	},
	bifrost_chain: {
		discord: 'https://discord.gg/8DRBw2h5X4',
		github: 'https://github.com/bifrost-io/bifrost',
		reddit: 'https://www.reddit.com/r/bifrostfinance',
		telegram: 'https://t.me/bifrost_finance',
		twitter: 'https://x.com/Bifrost',
		website: 'https://bifrost.finance',
	},
	bitcoin_chain: {
		reddit: 'https://www.reddit.com/r/Bitcoin/',
		twitter: 'https://x.com/Bitcoin',
		website: 'https://bitcoin.org/',
	},
	bitgert_chain: {
		telegram: 'https://t.me/bitgertbrise',
		twitter: 'https://x.com/bitgertbrise',
		website: 'https://bitgert.com/',
	},
	blast_chain: {
		discord: 'https://discord.gg/blast-l2',
		twitter: 'https://x.com/Blast',
		website: 'https://blast.io/',
	},
	blockdag_chain: {
		discord: 'https://discord.gg/Q7BxghMVyu',
		telegram: 'https://t.me/blockDAGnetworkOfficial',
		twitter: 'https://x.com/blockdagnetwork',
		website: 'https://blockdag.network/',
		youtube: 'https://www.youtube.com/@BlockDAGofficial',
	},
	bnb_chain: {
		discord: 'https://discord.gg/QRTQvfhADQ',
		github: 'https://github.com/bnb-chain',
		reddit: 'https://www.reddit.com/r/bnbchainofficial/',
		telegram: 'https://t.me/bnbchain',
		twitter: 'https://x.com/BNBChain',
		website: 'https://www.bnbchain.org/',
		youtube: 'https://www.youtube.com/channel/UCG9fZu6D4I83DStktBV0Ryw',
	},
	bnb_greenfield_chain: {
		discord: 'https://discord.com/invite/bnbchain',
		github: 'https://github.com/bnb-chain/greenfield',
		twitter: 'https://x.com/BNBChainDevs',
		website: 'https://greenfield.bnbchain.org/',
	},
	bsv_chain: {
		twitter: 'https://x.com/BSVBlockchain',
		website: 'https://bsvblockchain.org/',
	},
	cardano_chain: {
		github: ['https://github.com/cardano-foundation', 'https://github.com/IntersectMBO'],
		reddit: 'https://www.reddit.com/r/cardano/',
		telegram: 'https://t.me/CardanoAnnouncements',
		twitter: 'https://x.com/Cardano',
		website: 'https://cardano.org/',
		youtube: 'https://www.youtube.com/@CardanoFoundation',
	},
	celestia_chain: {
		discord: 'https://discord.com/invite/YsnTPcSfWQ',
		github: 'https://github.com/celestiaorg/',
		reddit: 'https://www.reddit.com/r/CelestiaNetwork/',
		telegram: 'https://t.me/CelestiaCommunity/',
		twitter: 'https://x.com/celestia',
		website: 'https://celestia.org/',
	},
	celo_chain: {
		discord: 'https://discord.gg/celo',
		github: 'https://github.com/celo-org',
		reddit: 'https://www.reddit.com/r/celo/',
		telegram: 'https://t.me/celoplatform',
		twitter: 'https://x.com/Celo',
		website: 'https://celo.org/',
		youtube: 'https://www.youtube.com/@CeloOrg',
	},
	chainlink_chain: {
		discord: 'https://discord.com/invite/chainlink',
		github: 'https://github.com/smartcontractkit',
		reddit: 'https://www.reddit.com/r/Chainlink/',
		telegram: 'https://t.me/chainlinkofficial',
		twitter: 'https://x.com/chainlink',
		website: 'https://chain.link/',
		youtube: 'https://www.youtube.com/@chainlink',
	},
	chromia_chain: {
		discord: 'https://discord.gg/chromia',
		telegram: 'https://t.me/hellochromia',
		twitter: 'https://x.com/Chromia',
		website: 'https://chromia.com/',
	},
	concordium_chain: {
		discord: 'https://discord.com/invite/GpKGE2hCFx',
		github: 'https://github.com/Concordium',
		reddit: 'https://www.reddit.com/r/Concordium_Official/',
		telegram: 'https://t.me/concordium_official',
		twitter: 'https://x.com/concordiumnet',
		website: 'https://www.concordium.com/',
		youtube: 'https://www.youtube.com/@ConcordiumNet',
	},
	core_chain: {
		discord: 'https://discord.gg/SCxmFr5Pwp',
		github: 'https://github.com/core-coin',
		reddit: 'https://www.reddit.com/r/CoreCoinCC/',
		telegram: 'https://t.me/coreblockchaincc',
		twitter: 'https://x.com/corecoincc',
		website: 'https://coreblockchain.net/',
		youtube: 'https://www.youtube.com/c/coreblockchain',
	},
	cosmos_chain: {
		discord: 'https://discord.gg/interchain',
		github: 'https://github.com/cosmos',
		reddit: 'https://reddit.com/r/cosmosnetwork',
		telegram: 'https://t.me/cosmosproject',
		twitter: 'https://x.com/cosmos',
		website: 'https://cosmos.network/',
		youtube: 'https://www.youtube.com/@interchain_io',
	},
	cronos_chain: {
		discord: 'https://discord.com/invite/pahqHz26q4',
		telegram: 'https://t.me/Cronos_Announcements',
		twitter: 'https://x.com/cronos_chain',
		website: 'https://cronos.org/',
	},
	crust_chain: {
		discord: 'https://discord.gg/zJtChDk4yW',
		github: 'https://github.com/crustio',
		telegram: 'https://t.me/CrustNetwork',
		twitter: 'https://x.com/CrustNetwork',
		website: 'https://crust.network/',
	},
	ecash_chain: {
		discord: 'https://discord.gg/ecash-official-852595915159896114',
		github: 'https://github.com/bitcoin-abc/',
		reddit: 'https://reddit.com/r/ecash',
		telegram: 'https://t.me/ecash',
		twitter: 'https://x.com/ecashofficial',
		website: 'https://e.cash/',
		youtube: 'https://www.youtube.com/eCashOfficial',
	},
	electra_protocol_chain: {
		discord: 'https://discord.gg/eCSQMJsKpw',
		reddit: 'https://www.reddit.com/r/ElectraProtocol/',
		telegram: 'https://t.me/ElectraProtocol',
		twitter: 'https://x.com/ElectraProtocol',
		website: 'https://www.electraprotocol.com/',
		youtube: 'https://www.youtube.com/c/ElectraProtocol',
	},
	electroneum_chain: {
		github: 'https://github.com/electroneum',
		reddit: 'https://www.reddit.com/r/Electroneum/',
		telegram: 'https://t.me/officialelectroneum',
		twitter: 'https://x.com/electroneum',
		website: 'https://electroneum.com/',
		youtube: 'https://www.youtube.com/@ElectroneumOfficial',
	},
	eos_chain: {
		github: 'https://github.com/eosnetworkfoundation',
		reddit: 'https://www.reddit.com/r/eos/',
		telegram: 'https://t.me/EOS_Global',
		twitter: 'https://x.com/EOSNetworkFDN',
		website: 'https://eosnetwork.com/',
		youtube: 'https://www.youtube.com/@EOSNetworkFoundation',
	},
	ethereum_chain: {
		discord: 'https://discord.gg/ethereum-org',
		github: 'https://github.com/ethereum/ethereum-org-website',
		reddit: 'https://www.reddit.com/r/ethereum/',
		twitter: 'https://x.com/ethdotorg',
		website: 'https://ethereum.org/',
		youtube: 'https://www.youtube.com/@EthereumProtocol',
	},
	etherlink_chain: {
		discord: 'https://discord.gg/etherlink',
		github: 'https://github.com/etherlinkcom',
		twitter: 'https://x.com/etherlink',
		website: 'https://www.etherlink.com/',
	},
	fantom_chain: {
		reddit: 'https://www.reddit.com/r/FantomFoundation/',
		twitter: 'https://x.com/FantomFDN',
		website: 'https://fantom.foundation/',
		youtube: 'https://www.youtube.com/@FantomFoundationOfficial',
	},
	flow_chain: {
		discord: 'https://discord.com/invite/J6fFnh2xx6',
		github: 'https://github.com/onflow',
		reddit: 'https://www.reddit.com/r/FlowBlockchain/',
		telegram: 'https://t.me/flow_blockchain',
		twitter: 'https://x.com/flow_blockchain',
		website: 'https://flow.com/',
		youtube: 'https://www.youtube.com/@FlowBlockchain',
	},
	fogo_chain: {
		discord: 'https://discord.gg/FogoChain',
		twitter: 'https://x.com/fogochain',
		website: 'https://www.fogo.io/',
	},
	frequency_chain: {
		discord: 'https://discord.com/invite/JchmHX5afV',
		github: 'https://github.com/frequency-chain/frequency',
		twitter: 'https://x.com/one_frequency',
		website: 'https://www.frequency.xyz/',
	},
	gnosis_chain: {
		discord: 'https://t.co/Ug9m92VjGe',
		github: 'https://github.com/gnosischain',
		reddit: 'https://www.reddit.com/r/gnosisPM/',
		twitter: 'https://x.com/gnosischain',
		website: 'https://www.gnosis.io/',
		youtube: 'https://www.youtube.com/@GnosisChain',
	},
	gravity_chain: {
		discord: 'https://discord.gg/GravityChain',
		telegram: 'http://t.me/GravityChain',
		twitter: 'https://x.com/GravityChain',
		website: 'https://gravity.xyz/',
	},
	haven1_chain: {
		discord: 'https://discord.gg/haven1',
		telegram: 'https://t.me/Haven1_Official',
		twitter: 'https://x.com/Haven1official',
		website: 'https://haven1.org/',
		youtube: 'https://www.youtube.com/@haven1official',
	},
	hedera_chain: {
		discord: 'https://hedera.com/discord',
		github: 'https://github.com/hashgraph',
		reddit: 'https://www.reddit.com/r/Hedera/',
		telegram: 'https://t.me/hederahashgraph',
		twitter: 'https://x.com/hedera',
		website: 'https://hedera.com/',
		youtube: 'https://www.youtube.com/@HederaHashgraph',
	},
	hive_chain: {
		discord: 'https://myhive.li/discord',
		github: 'https://github.com/openhive-network',
		reddit: 'https://reddit.com/r/hivenetwork',
		telegram: 'https://t.me/hiveblockchain',
		twitter: 'https://x.com/hiveblocks',
		website: 'https://hive.io/',
		youtube: 'https://www.youtube.com/@Hivenetwork',
	},
	hydration_chain: {
		discord: 'https://discord.gg/kkmY35UxAG',
		github: 'https://github.com/galacticcouncil',
		telegram: 'https://t.me/hydration_net',
		twitter: 'https://x.com/hydration_net',
		website: 'https://hydration.net',
	},
	hyperliquid_chain: {
		discord: 'https://discord.gg/hyperliquid',
		github: 'https://github.com/hyperliquid-dex',
		reddit: 'https://www.reddit.com/r/Hyperliquid/',
		twitter: 'https://x.com/HyperliquidX',
		website: 'https://hyperliquid.xyz/',
	},
	icp_chain: {
		github: 'https://github.com/dfinity',
		reddit: 'https://www.reddit.com/r/dfinity/',
		telegram: 'https://t.me/+m8tiEFaaNR8xNjNl',
		twitter: 'https://x.com/dfinity',
		website: 'https://internetcomputer.org/',
		youtube: 'https://www.youtube.com/@DFINITY',
	},
	integritee_chain: {
		discord: 'https://discord.com/invite/wwGcqhfXtZ',
		github: 'https://github.com/integritee-network',
		reddit: 'https://www.reddit.com/r/Integritee/',
		telegram: 'https://t.me/Integritee_Official',
		twitter: 'https://x.com/integri_t_e_e',
		website: 'https://www.integritee.network/',
		youtube: 'https://www.youtube.com/@integriteenetwork',
	},
	iota_chain: {
		discord: 'https://discord.iota.org/',
		github: 'https://github.com/iotaledger',
		reddit: 'https://www.reddit.com/r/Iota/',
		telegram: 'https://telegram.me/iotatangle',
		twitter: 'https://x.com/iota',
		website: 'https://www.iota.org/',
		youtube: 'https://www.youtube.com/@iotafoundation',
	},
	iotex_chain: {
		discord: 'https://discord.com/invite/q5eYde2CU7',
		github: 'https://github.com/iotexproject',
		reddit: 'https://www.reddit.com/r/IoTeX/',
		telegram: 'https://t.me/IoTeXGroup',
		twitter: 'https://x.com/iotex_io',
		website: 'https://iotex.io/',
		youtube: 'https://www.youtube.com/@IoTeXOfficialChannel',
	},
	kaspa_chain: {
		discord: 'http://discord.gg/kaspa',
		github: 'https://github.com/kaspanet',
		reddit: 'https://www.reddit.com/r/kaspa/',
		telegram: 'https://t.me/kaspaenglish',
		twitter: 'https://x.com/KaspaCurrency',
		website: 'https://kaspa.org/',
		youtube: 'https://www.youtube.com/@kaspaCurrency',
	},
	kava_chain: {
		discord: 'https://discord.com/invite/q6QuanE4bx',
		github: 'https://github.com/kava-labs',
		reddit: 'https://www.reddit.com/r/kava_platform',
		telegram: 'https://t.me/kavalabs',
		twitter: 'https://x.com/KAVA_CHAIN',
		website: 'https://www.kava.io',
	},
	keeta_chain: {
		discord: 'https://discord.gg/keeta',
		twitter: 'https://x.com/keetanetwork',
		website: 'https://keeta.com/',
	},
	klaytn_chain: {
		discord: 'https://discord.gg/KlaytnOfficial',
		github: 'https://github.com/klaytn',
		reddit: 'https://www.reddit.com/r/klaytn/',
		telegram: 'https://t.me/Klaytn_EN',
		twitter: 'https://x.com/klaytn_official',
		website: 'https://klaytn.foundation/',
		youtube: 'https://www.youtube.com/@Klaytn_Official',
	},
	klever_chain: {
		twitter: 'https://x.com/klever_org',
		website: 'https://klever.org/',
	},
	kusama_chain: {
		discord: 'https://kusa.ma/discord',
		github: 'https://github.com/paritytech/polkadot-sdk/',
		reddit: 'https://www.reddit.com/r/Kusama/',
		twitter: 'https://x.com/kusamanetwork',
		website: 'https://kusama.network/',
		youtube: 'https://www.youtube.com/@KusamaNetwork',
	},
	linea_chain: {
		discord: 'https://discord.gg/linea',
		twitter: 'https://x.com/LineaBuild',
		website: 'https://linea.build/',
		youtube: 'https://www.youtube.com/@LineaBuild',
	},
	litentry_chain: {
		discord: 'https://discord.gg/6KxSqDPgWh',
		github: 'https://github.com/litentry/heima',
		telegram: 'https://t.me/Litentry',
		twitter: 'https://x.com/litentry',
		website: 'https://www.litentry.com',
	},
	mantle_chain: {
		discord: 'https://discord.com/invite/0xMantle',
		github: 'https://github.com/mantlenetworkio',
		reddit: 'https://www.reddit.com/r/0xMantle/',
		telegram: 'https://t.me/mantlenetwork',
		twitter: 'https://x.com/0xMantle',
		website: 'https://www.mantle.xyz/',
		youtube: 'https://www.youtube.com/@0xMantle',
	},
	massa_chain: {
		discord: 'https://discord.com/invite/massa',
		github: 'https://github.com/massalabs/massa',
		reddit: 'https://www.reddit.com/r/massa/',
		telegram: 'https://t.me/massanetwork',
		twitter: 'https://x.com/massachain/',
		website: 'https://massa.net/',
		youtube: 'https://www.youtube.com/@massa_chain',
	},
	matchain_chain: {
		discord: 'https://discord.com/invite/matchain',
		telegram: 'https://t.me/matchain_fam',
		twitter: 'https://x.com/matchain_io',
		website: 'https://www.matchain.io/',
		youtube: 'https://www.youtube.com/@MatchChain',
	},
	mazze_chain: {
		discord: 'https://discord.mazze.io/',
		github: 'https://github.com/MazzeLabs',
		telegram: 'https://t.me/MazzeLabs',
		twitter: 'https://x.com/MazzeLabs',
		website: 'https://mazze.io/',
	},
	megaeth_chain: {
		discord: 'https://discord.com/invite/megaeth',
		github: 'https://github.com/megaeth-labs',
		telegram: 'https://t.me/+wN8geyhVpE8yNmRl',
		twitter: 'https://x.com/megaeth_labs',
		website: 'https://www.megaeth.com/',
	},
	monad_chain: {
		discord: 'http://discord.gg/monad',
		telegram: 'https://t.me/monad_xyz',
		twitter: 'https://x.com/monad_xyz',
		website: 'https://www.monad.xyz/',
	},
	moonbeam_chain: {
		discord: 'https://discord.com/invite/PfpUATX',
		github: 'https://github.com/PureStake/moonbeam',
		reddit: 'https://www.reddit.com/r/moonbeam/',
		telegram: 'https://t.me/Moonbeam_Official',
		twitter: 'https://x.com/moonbeamnetwork',
		website: 'https://moonbeam.network/',
		youtube: 'https://www.youtube.com/@MoonbeamNetwork',
	},
	multiversx_chain: {
		discord: 'https://discord.gg/multiversxbuilders',
		github: 'https://github.com/MultiversX',
		reddit: 'https://www.reddit.com/r/MultiversXOfficial/',
		telegram: 'https://t.me/MultiversXAnn',
		twitter: 'https://x.com/MultiversX',
		website: 'https://multiversx.com/',
		youtube: 'https://www.youtube.com/@MultiversXOfficial',
	},
	mythos_chain: {
		discord: 'https://discord.gg/6tmvUYEfMr',
		twitter: 'https://x.com/EnterTheMythos',
		website: 'https://mythos.foundation',
	},
	near_chain: {
		discord: 'http://near.chat/',
		github: 'https://github.com/near',
		reddit: 'https://www.reddit.com/r/nearprotocol/',
		telegram: 'https://t.me/cryptonear',
		twitter: 'https://x.com/nearprotocol',
		website: 'https://near.org/',
		youtube: 'https://www.youtube.com/@NEARProtocol',
	},
	neuroweb_chain: {
		discord: 'https://discordapp.com/invite/FCgYk2S',
		github: 'https://github.com/OriginTrail/neuroweb',
		reddit: 'https://www.reddit.com/r/OriginTrail/',
		telegram: 'https://t.me/origintrail',
		twitter: 'https://x.com/NeuroWebAI',
		website: 'https://neuroweb.ai/',
	},
	nexa_chain: {
		discord: 'https://discord.com/invite/WJhWUEYSse',
		github: 'https://gitlab.com/nexa',
		reddit: 'https://www.reddit.com/r/Nexa/',
		telegram: 'https://t.me/nexacoin',
		twitter: 'https://x.com/nexamoney',
		website: 'https://nexa.org/',
		youtube: 'https://www.youtube.com/@NexaCoin',
	},
	opbnb_chain: {
		discord: 'https://discord.com/invite/bnbchain',
		twitter: 'https://x.com/BNBCHAIN',
		website: 'https://opbnb.bnbchain.org/',
	},
	optimism_chain: {
		discord: 'https://discord.gg/optimism',
		github: 'https://github.com/ethereum-optimism',
		twitter: 'https://x.com/optimism',
		website: 'https://www.optimism.io/',
	},
	particle_chain: {
		discord: 'https://discord.com/invite/2y44qr6CR2',
		twitter: 'https://x.com/ParticleNtwrk',
		website: 'https://particle.network/',
	},
	peaq_chain: {
		discord: 'https://discord.gg/XhJwuFKAAD',
		github: 'https://github.com/peaqnetwork/peaq-network-node',
		telegram: 'https://t.me/peaqnetwork',
		twitter: 'https://x.com/peaq',
		website: 'https://www.peaq.network',
	},
	pendulum_chain: {
		discord: 'https://discord.gg/wJ2fQh776B',
		github: 'https://github.com/pendulum-chain/pendulum-prototype',
		reddit: 'https://www.reddit.com/r/Pendulum_Chain',
		telegram: 'https://t.me/pendulum_chain',
		twitter: 'https://x.com/pendulum_chain',
		website: 'https://pendulumchain.org',
	},
	phala_chain: {
		discord: 'https://discord.com/invite/phala-network',
		github: 'https://github.com/Phala-Network/phala-blockchain',
		telegram: 'https://t.me/joinchat/I-ejoxKrdHlOx_zv9VsykA',
		twitter: 'https://x.com/PhalaNetwork',
		website: 'https://phala.network',
	},
	polkadex_chain: {
		discord: 'https://discord.com/invite/Uvua83QAzk',
		reddit: 'https://www.reddit.com/r/polkadex',
		telegram: 'https://t.me/Polkadex',
		twitter: 'https://x.com/polkadex',
		website: 'https://polkadex.trade/',
		youtube: 'https://www.youtube.com/@Polkadex',
	},
	polkadot_relay_chain: {
		discord: 'https://dot.li/discord',
		github: 'https://github.com/paritytech/polkadot',
		reddit: 'https://www.reddit.com/r/polkadot',
		telegram: 'https://t.me/PolkadotOfficial?ref=cms.polkadot.network',
		twitter: 'https://x.com/Polkadot',
		website: 'https://polkadot.network/',
		youtube: 'https://www.youtube.com/@PolkadotNetwork',
	},
	polygon_chain: {
		discord: 'https://discord.com/invite/0xPolygon',
		github: 'https://github.com/maticnetwork/',
		reddit: 'https://www.reddit.com/r/polygonnetwork/',
		telegram: 'https://t.me/polygonofficial',
		twitter: 'https://x.com/0xPolygon',
		website: 'https://polygon.technology/',
	},
	quai_chain: {
		discord: 'https://discord.com/invite/ngw88VXXnV',
		reddit: 'https://www.reddit.com/r/quainetwork/',
		twitter: 'https://x.com/QuaiNetwork',
		website: 'https://qu.ai/',
		youtube: 'https://www.youtube.com/@QuaiNetwork',
	},
	qubic_chain: {
		discord: 'https://discord.com/invite/qubic',
		github: 'https://github.com/qubic',
		telegram: 'https://t.me/qubic_network',
		twitter: 'https://x.com/_qubic_',
		website: 'https://qubic.org/',
		youtube: 'https://www.youtube.com/@_qubic_',
	},
	radix_chain: {
		discord: 'http://discord.gg/radixdlt',
		github: 'https://github.com/radixdlt',
		reddit: 'https://www.reddit.com/r/Radix/',
		telegram: 'https://t.me/radix_dlt',
		twitter: 'https://x.com/RadixDLT',
		website: 'https://www.radixdlt.com/',
		youtube: 'https://www.youtube.com/@RadixDLT',
	},
	redbelly_chain: {
		discord: 'https://discord.com/invite/redbelly',
		telegram: 'https://t.me/redbellychat',
		twitter: 'https://x.com/RedbellyNetwork',
		website: 'https://redbelly.network/',
		youtube: 'https://www.youtube.com/@redbellynetwork',
	},
	reddio_chain: {
		discord: 'https://discord.com/invite/reddio',
		github: 'https://github.com/reddio-com',
		twitter: 'https://x.com/reddio_com',
		website: 'https://www.reddio.com/',
	},
	rise_chain: {
		discord: 'https://discord.com/invite/risechain',
		github: 'https://github.com/risechain',
		twitter: 'https://x.com/rise_chain',
		website: 'https://risechain.com/',
	},
	robonomics_chain: {
		github: 'https://github.com/airalab/robonomics',
		telegram: 'https://t.me/robonomics',
		twitter: 'https://x.com/AIRA_Robonomics',
		website: 'https://robonomics.network',
	},
	scroll_chain: {
		discord: 'https://discord.gg/scroll',
		github: 'https://github.com/scroll-tech',
		twitter: 'https://x.com/Scroll_ZKP',
		website: 'https://scroll.io/',
		youtube: 'https://www.youtube.com/@Scroll_ZKP',
	},
	sei_chain: {
		discord: 'https://discord.com/invite/sei',
		github: 'https://github.com/sei-protocol',
		telegram: 'https://t.me/seinetwork',
		twitter: 'https://x.com/SeiNetwork',
		website: 'https://www.sei.io/',
	},
	sirius_chain: {
		discord: 'https://discord.gg/QGsDQqv5vX',
		github: 'https://github.com/proximax-storage',
		reddit: 'https://www.reddit.com/r/ProximaXOfficial/',
		telegram: 'https://t.me/ProximaXio',
		twitter: 'https://x.com/SiriusXPX',
		website: 'https://www.siriuschain.io/',
		youtube: 'https://www.youtube.com/c/ProximaXio',
	},
	skale_chain: {
		twitter: 'https://x.com/SkaleNetwork',
		website: 'https://skale.space',
	},
	solana_chain: {
		discord: 'https://solana.com/discord',
		github: 'https://solana.com/github',
		reddit: 'https://solana.com/reddit',
		telegram: 'https://solana.com/telegram',
		twitter: 'https://solana.com/twitter',
		website: 'https://solana.com/',
		youtube: 'https://solana.com/youtube',
	},
	somnia_chain: {
		discord: 'https://discord.gg/somnia',
		twitter: 'https://x.com/Somnia_Network',
		website: 'https://somnia.network/',
	},
	sonic_chain: {
		discord: 'https://discord.gg/3Ynr2QDSnB',
		reddit: 'https://www.reddit.com/r/0xSonic/',
		telegram: 'https://t.me/Sonic_English',
		twitter: 'https://x.com/SonicLabs',
		website: 'https://www.soniclabs.com/',
	},
	starknet_chain: {
		discord: 'https://starknet.io/discord',
		github: 'https://github.com/keep-starknet-strange/awesome-starknet',
		twitter: 'https://x.com/Starknet',
		website: 'https://www.starknet.io/',
		youtube: 'https://www.youtube.com/@starkware_ltd',
	},
	stellar_chain: {
		discord: 'https://discord.com/invite/zVYdY3ktTn',
		github: 'https://github.com/stellar',
		reddit: 'https://www.reddit.com/r/Stellar/',
		telegram: 'https://t.me/StellarLumens',
		twitter: 'https://x.com/StellarOrg',
		website: 'https://stellar.org/',
		youtube: 'https://www.youtube.com/@StellarDevelopmentFoundation',
	},
	sui_chain: {
		discord: 'https://discord.com/invite/sui',
		github: 'https://github.com/sui-foundation',
		reddit: 'https://www.reddit.com/r/sui/',
		twitter: 'https://x.com/SuiNetwork',
		website: 'https://sui.io/',
		youtube: 'https://www.youtube.com/@Sui-Network',
	},
	supra_chain: {
		discord: 'https://discord.com/invite/supralabs',
		telegram: 'https://t.me/SupraOracles',
		twitter: 'https://x.com/SUPRA_Labs',
		website: 'https://supra.com/',
		youtube: 'https://www.youtube.com/SupraOfficial',
	},
	taraxa_chain: {
		discord: 'https://taraxa.io/discord',
		github: 'https://github.com/Taraxa-project',
		reddit: 'https://www.reddit.com/r/Taraxa_Project/',
		telegram: 'https://t.me/taraxa_project',
		twitter: 'https://x.com/taraxa_project',
		website: 'https://www.taraxa.io/',
		youtube: 'https://www.youtube.com/@taraxa',
	},
	tectum_chain: {
		discord: 'https://discord.gg/TXREkPY8C7',
		reddit: 'https://www.reddit.com/r/tectumcrypto/',
		telegram: 'https://t.me/tectumglobal',
		twitter: 'https://x.com/tectumsocial',
		website: 'https://tectum.io/',
		youtube: 'https://www.youtube.com/@Tectum_the_fastest_blockchain',
	},
	telos_chain: {
		discord: 'https://discord.gg/telos',
		github: 'https://github.com/telosnetwork',
		reddit: 'https://www.reddit.com/r/TELOS/',
		telegram: 'http://t.me/HelloTelos',
		twitter: 'https://x.com/HelloTelos',
		website: 'https://www.telos.net/',
		youtube: 'https://www.youtube.com/@TheTelosNetwork',
	},
	terra_chain: {
		discord: 'https://terra.sc/discord',
		github: 'https://github.com/terra-money',
		reddit: 'https://www.reddit.com/r/terraluna/',
		telegram: 'https://t.me/TerraNetworkLobby',
		twitter: 'https://x.com/terra_money',
		website: 'https://www.terra.money/',
		youtube: 'https://www.youtube.com/@Terra_Money',
	},
	tezos_chain: {
		discord: 'https://discord.com/invite/tezos-blockchain-699325006928281720',
		github: 'https://github.com/tezos/tezos',
		reddit: 'https://www.reddit.com/r/tezos',
		telegram: ['https://t.me/TezosPlatform', 'https://t.me/TezosAnnouncements'],
		twitter: 'https://x.com/tezos',
		website: 'https://tezos.com/',
		youtube: 'https://www.youtube.com/@Tezos',
	},
	ton_chain: {
		github: 'https://github.com/ton-blockchain',
		telegram: 'https://t.me/toncoin',
		twitter: 'https://x.com/ton_blockchain',
		website: 'https://ton.org/',
	},
	tron_chain: {
		discord: 'https://discord.gg/hqKvyAM',
		github: 'https://github.com/tronprotocol',
		reddit: 'https://www.reddit.com/r/Tronix/',
		telegram: 'https://t.me/tronnetworkEN',
		twitter: 'https://x.com/trondao',
		website: 'https://tron.network/',
		youtube: 'https://www.youtube.com/@TRONDAOofficial',
	},
	u2u_chain: {
		discord: 'https://discord.com/invite/6bPaDU8pk3',
		telegram: 'https://t.me/u2u_xyz',
		twitter: 'https://x.com/u2u_xyz',
		website: 'https://u2u.xyz/',
		youtube: 'https://www.youtube.com/@u2u_network',
	},
	unichain_chain: {
		discord: 'https://discord.com/invite/uniswap',
		twitter: 'https://x.com/unichain',
		website: 'https://www.unichain.org/',
	},
	vechain_chain: {
		github: 'https://github.com/vechain',
		reddit: 'https://reddit.com/r/vechain',
		telegram: 'https://t.me/vechainandfriends',
		twitter: 'https://x.com/vechainofficial',
		website: 'https://vechain.org/',
	},
	wanchain_chain: {
		github: 'https://github.com/wanchain',
		reddit: 'https://www.reddit.com/r/wanchain/',
		telegram: 'https://t.me/WanchainCHAT',
		twitter: 'https://x.com/wanchain_org',
		website: 'https://www.wanchain.org/',
		youtube: 'https://www.youtube.com/@Wanchain',
	},
	waterfall_chain: {
		discord: 'https://discord.gg/Nwb8aR2XvR',
		github: 'https://github.com/waterfall-network',
		telegram: 'https://t.me/waterfall_network',
		twitter: 'https://x.com/waterfall_dag',
		website: 'https://waterfall.network/',
		youtube: 'https://www.youtube.com/@waterfall_network',
	},
	xelis_chain: {
		discord: 'https://discord.gg/xelis',
		github: 'https://github.com/xelis-project',
		reddit: 'https://www.reddit.com/r/xelis',
		telegram: 'https://t.me/xelis_io',
		twitter: 'https://x.com/xelis_project',
		website: 'https://xelis.io',
		youtube: 'https://youtube.com/@xelis_project',
	},
	xrpl_chain: {
		github: 'https://github.com/XRPLF/',
		reddit: 'https://www.reddit.com/r/XRP/',
		telegram: 'https://t.me/Ripple',
		twitter: 'https://x.com/Ripple',
		website: 'https://xrpl.org/',
		youtube: 'https://www.youtube.com/@Ripple',
	},
	xx_chain: {
		discord: 'https://discord.xx.network/',
		github: 'https://github.com/xx-labs',
		telegram: 'https://t.me/xxnetwork',
		twitter: 'https://x.com/xx_network',
		website: 'https://xx.network/',
		youtube: 'https://www.youtube.com/@xxnetwork',
	},
	zeitgeist_chain: {
		discord: 'https://discord.com/invite/xv8HuA4s8v',
		github: 'https://github.com/ZeitgeistPM',
		telegram: 'https://blog.zeitgeist.pm/',
		twitter: 'https://x.com/ZeitgeistPM',
		website: 'https://zeitgeist.pm/',
		youtube: 'https://www.youtube.com/@zeitgeistpm',
	},
}
